import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import BlogFeature from './features/blog'
import CheckinFeature from './features/checkin'
import EmailFeature from './features/email'
import EventsFeature from './features/events'
import FormsFeature from './features/forms'
import ForumsFeature from './features/forums'
import IntegrationsFeature from './features/integrations'
import LiveEventsFeature from './features/liveevents'
import MarketplaceFeature from './features/marketplace'
import MessagesFeature from './features/messages'
import PaymentsFeature from './features/payments'
import PrivacyFeature from './features/privacy'
import ProfileFeature from './features/profile'
import ThemeFeature from './features/theme'
import AnalyticsFeature from './features/analytics'

const Blank = () => <div />

const featureComponents = {
   blank: {
      component: Blank,
      backgroundColor: 'bg-neutral-950'
   },
   analytics: {
      component: AnalyticsFeature,
      backgroundColor: 'bg-blue-950'
   },
   blog: {
      component: BlogFeature,
      backgroundColor: 'bg-lime-950/50'
   },
   checkin: {
      component: CheckinFeature,
      backgroundColor: 'bg-emerald-950'
   },
   email: {
      component: EmailFeature,
      backgroundColor: 'bg-cyan-950'
   },
   events: {
      component: EventsFeature,
      backgroundColor: 'bg-amber-950/50'
   },
   forms: {
      component: FormsFeature,
      backgroundColor: 'bg-orange-900/70'
   },
   forums: {
      component: ForumsFeature,
      backgroundColor: 'bg-[#1e1a29]'
   },
   integrations: {
      component: IntegrationsFeature,
      backgroundColor: 'bg-emerald-950/50'
   },
   liveevents: {
      component: LiveEventsFeature,
      backgroundColor: 'bg-cyan-950/50'
   },
   marketplace: {
      component: MarketplaceFeature,
      backgroundColor: 'bg-emerald-950'
   },
   messaging: {
      component: MessagesFeature,
      backgroundColor: 'bg-cyan-950/50'
   },
   payments: {
      component: PaymentsFeature,
      backgroundColor: 'bg-green-950/70'
   },
   privacy: {
      component: PrivacyFeature,
      backgroundColor: 'bg-green-950'
   },
   profile: {
      component: ProfileFeature,
      backgroundColor: 'bg-amber-950/70'
   },
   theme: {
      component: ThemeFeature,
      backgroundColor: 'bg-emerald-950/50'
   }
}

const FeatureBlockMediaContainer = ({ children, featureKeyName }) => {
   const { backgroundColor } = featureComponents[featureKeyName]

   return (
      <div
         className={classNames(
            'absolute top-0 left-0 w-full h-full transition-colors duration-700',
            backgroundColor
         )}>
         {children}
      </div>
   )
}

FeatureBlockMediaContainer.propTypes = {
   children: PropTypes.node.isRequired,
   featureKeyName: PropTypes.string.isRequired
}

const FeatureBlockMedia = ({ featureKeyName, active }) => {
   const { component } = featureComponents[featureKeyName]
   const FeatureComponent = component

   return (
      <div className={classNames('w-full h-full', active ? 'block' : 'hidden')}>
         <FeatureComponent active={active} />
      </div>
   )
}

FeatureBlockMedia.propTypes = {
   active: PropTypes.bool.isRequired,
   featureKeyName: PropTypes.string.isRequired
}

export { FeatureBlockMedia, FeatureBlockMediaContainer }
